import {createContext, ReactNode, useContext, useState} from "react";

const TemplateContext = createContext({
    template: "default",
    // @ts-ignore
    setTemplate: (t: string) => {}
});

interface TemplateProviderProps {
    children: ReactNode;
}

export const TemplateProvider: React.FC<TemplateProviderProps> = ({ children } ) => {
    const [template, setTemplate] = useState(import.meta.env.VITE_TEMPLATE_NAME ?? "ld-quiz-1");
    return (
        <TemplateContext.Provider value={{ template, setTemplate }}>
            {children}
        </TemplateContext.Provider>
    );
};

export const useTemplate = () => useContext(TemplateContext);